export default __webpack_public_path__ + "static/media/4.355f3c0b.jpg";